import { Link } from 'react-router-dom';
import PageLayout from '../../components/feature/PageLayout';
import PageHero from '../../components/feature/PageHero';
import FadeIn from '../../components/base/FadeIn';
import hizmetlerHero from '../../assets/images/hero-hizmetler.jpg';
import { WHATSAPP_CHAT_URL } from '../../config/contactLinks';

const services = [
  { icon: 'ri-building-4-line', title: 'İnşaat Sonrası Temizlik', desc: 'Toz, çimento ve kir kalıntılarının derin temizliği. Anahtar teslim hazır.', detail: 'Tadilat ya da inşaat bitişi sonrası oluşan çimento tozu, alçı kalıntıları ve genel kiri ekibimiz özel ekipmanlarla temizler. Anahtar teslim standardında teslim garantisi.' },
  { icon: 'ri-home-4-line', title: 'Daire & Ofis Temizliği', desc: 'Günlük, haftalık veya aylık periyodik temizlik paketleri.', detail: 'Eviniz veya ofisiniz için özelleştirilmiş temizlik programı. Haftalık bakım ya da aylık derin temizlik paketleriyle mekan her zaman hazır.' },
  { icon: 'ri-hotel-line', title: 'Villa Temizliği', desc: 'Geniş alanlara özel detaylı temizlik. Her köşe, her yüzey.', detail: 'Villa ve büyük konutlarda kapsamlı temizlik; havuz çevresi, teras, çok katlı iç mekan. Tüm yüzeyler tek tek ele alınır.' },
  { icon: 'ri-key-line', title: 'Kiracı Sonrası Temizlik', desc: 'Çıkış temizliği ile mülkünüzü hızla yeni kiracıya hazırlıyoruz.', detail: 'Kiracı çıkışı sonrası kalan kir, iz ve lekelerden arındırılmış; yeni kiracı kabulüne hazır, taze bir mekan.' },
  { icon: 'ri-store-3-line', title: 'Kurumsal Mağaza Temizliği', desc: 'İşyeri ve mağazalar için özel temizlik çözümleri.', detail: 'Mesai öncesi ya da sonrası planlanan esnek saatlerde; vitrin, raf, zemin ve tüm dokunma noktaları titizlikle temizlenir.' },
  { icon: 'ri-restaurant-line', title: 'Kafe & Restaurant', desc: 'Gıda hijyen standartlarına uygun mutfak ve salon temizliği.', detail: 'Mutfak ekipmanı, ocak, davlumbaz, soğutucular ve salon; gıda güvenliği normlarına uygun sertifikalı ürünlerle temizlenir.' },
  { icon: 'ri-building-line', title: 'Dış Cephe Temizliği', desc: 'Yüksek basınçlı ekipmanlarla bina dış cephe yıkama.', detail: 'Yıllar içinde biriken hava kirliliği, mantar ve yosun gibi etkenlerden korunaklı makineli yıkama ile binanız yenilenir.' },
  { icon: 'ri-plant-line', title: 'Bahçe Temizliği', desc: 'Yaprak toplama, genel temizlik ve düzenleme hizmetleri.', detail: 'Mevsimsel yaprak temizliği, çim kenarı düzenleme ve bahçe genel bakım; mekanın her zaman düzenli görünmesi sağlanır.' },
  { icon: 'ri-community-line', title: 'Apartman Temizliği', desc: 'Merdiven, giriş ve ortak alan temizliği. Aylık kontrat.', detail: 'Site ve apartman ortak alanları; giriş, kat koridorları, asansör için haftalık veya aylık kontrat seçeneği.' },
  { icon: 'ri-window-line', title: 'Cam Temizliği', desc: 'İç ve dış cam yüzeyler için kristal netliğinde temizlik.', detail: 'Cam yüzeyler özel solüsyon ve mop sistemiyle lekesiz temizlenir; iç ve dış cephe dahil tüm camlar tek seferinde.' },
  { icon: 'ri-sofa-line', title: 'Koltuk & Halı Yıkama', desc: 'Buharlı derin yıkama ile hijyenik ve ferah dokumalar.', detail: 'Buhar ekstraksiyon makinesiyle derin yıkama; allerjen, bakteri ve koku tamamen giderilir, 4–6 saat kuruma süresi.' },
];

const features = [
  { icon: 'ri-shield-check-line', text: 'Sigortalı Ekip' },
  { icon: 'ri-leaf-line', text: 'Çevre Dostu Ürünler' },
  { icon: 'ri-time-line', text: 'Zamanında Hizmet' },
  { icon: 'ri-tools-line', text: 'Profesyonel Ekipman' },
];

export default function HizmetlerPage() {
  return (
    <PageLayout>
      <PageHero
        label="Hizmet Portföyü"
        title="11 Farklı Temizlik Hizmeti"
        subtitle="Konuttan ticari alana, inşaattan bahçeye kadar Niğde'nin en kapsamlı temizlik portföyü."
        bgImage={hizmetlerHero}
      />

      <section className="py-24 bg-white relative overflow-hidden">
        <div className="absolute -top-4 right-8 text-[220px] font-extrabold text-navy/[0.025] leading-none select-none pointer-events-none hidden lg:block">11</div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8">

          {/* Feature badges */}
          <FadeIn className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
            {features.map(f => (
              <div key={f.text} className="flex items-center gap-3 bg-[#f7f8fc] rounded-xl px-4 py-3.5">
                <span className="w-8 h-8 flex items-center justify-center bg-gold/10 rounded-lg shrink-0">
                  <i className={`${f.icon} text-gold text-base`}></i>
                </span>
                <span className="text-navy font-semibold text-sm">{f.text}</span>
              </div>
            ))}
          </FadeIn>

          {/* Services grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {services.map((svc, idx) => (
              <FadeIn key={svc.title} delay={(idx % 3) * 0.08}>
                <Link
                  to="/iletisim"
                  className="group relative bg-white border border-gray-100 rounded-xl p-7 hover:border-transparent transition-all duration-300 cursor-pointer overflow-hidden h-full block"
                  style={{ boxShadow: '0 1px 4px rgba(26,43,94,0.06)' }}
                  onMouseEnter={e => { (e.currentTarget as HTMLElement).style.boxShadow = '0 10px 36px rgba(201,168,76,0.16)'; }}
                  onMouseLeave={e => { (e.currentTarget as HTMLElement).style.boxShadow = '0 1px 4px rgba(26,43,94,0.06)'; }}
                >
                  <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-transparent via-gold to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <span className="absolute top-5 right-5 text-[11px] font-extrabold text-navy/10 group-hover:text-gold/50 transition-colors tracking-wider">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <div className="w-12 h-12 flex items-center justify-center bg-navy/5 rounded-xl mb-5 group-hover:bg-gold group-hover:scale-110 transition-all duration-300">
                    <i className={`${svc.icon} text-navy group-hover:text-white text-xl transition-colors`}></i>
                  </div>
                  <h3 className="font-semibold text-navy text-[15px] mb-2 leading-snug pr-6">{svc.title}</h3>
                  <p className="text-gray-500 text-[13px] leading-relaxed mb-4">{svc.desc}</p>
                  <p className="text-gray-400 text-[13px] leading-relaxed border-t border-gray-100 pt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">{svc.detail}</p>
                  <div className="mt-4 flex items-center gap-1.5 text-[12px] font-bold text-gray-400 group-hover:text-gold transition-colors uppercase tracking-wider">
                    <span>Teklif Al</span>
                    <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                      <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </div>
                </Link>
              </FadeIn>
            ))}

            {/* CTA card */}
            <FadeIn delay={0.2}>
              <div className="relative bg-navy rounded-xl p-7 flex flex-col justify-between cursor-pointer overflow-hidden group h-full">
                <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-gold/10 rounded-full" />
                <div className="absolute -top-6 -left-6 w-24 h-24 bg-white/5 rounded-full" />
                <div className="relative z-10">
                  <div className="w-12 h-12 flex items-center justify-center bg-gold/20 rounded-xl mb-5">
                    <i className="ri-customer-service-2-line text-gold text-xl"></i>
                  </div>
                  <p className="text-white font-extrabold text-base mb-2">Ücretsiz Keşif</p>
                  <p className="text-white/70 text-sm leading-relaxed">Hangi hizmet size uygun? Bize danışın, size özel çözüm üretelim.</p>
                </div>
                <a href={WHATSAPP_CHAT_URL} target="_blank" rel="nofollow noreferrer"
                  className="relative z-10 mt-8 flex items-center gap-2 bg-gold hover:bg-gold-dark text-white px-4 py-2.5 rounded-lg text-xs font-bold whitespace-nowrap transition-colors w-fit">
                  <i className="ri-whatsapp-line text-sm"></i> WhatsApp&apos;tan Yaz
                </a>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
